/**
 * Eager shared deps in the sync entry chunk; app graph loads asynchronously (RUNTIME-006).
 */
import './federation-shared-deps';
import('./bootstrap');
